import axios from "axios";

export default class CirugiasService {
  allCirugias() {
    return axios.get(process.env.VUE_APP_API_PUBLIC + "cirugias/todas");
  }
  crearCirugia(data) {
    return axios.post(process.env.VUE_APP_API_PUBLIC + "cirugias/create", data);
  }
  editarCirugia(data) {
    return axios.put(process.env.VUE_APP_API_PUBLIC + "cirugias/update", data);
  }
  eliminarCirugia(data) {
    return axios.delete(process.env.VUE_APP_API_PUBLIC + "cirugias/delete", {
      data: data,
    });
  }
}
